import { Text } from 'react-native'
import { convertLineHeight, convertPercentageToNumber, styled } from '~/utils'

export const Root = styled(Text, theme => {
  return {
    base: {
      letterSpacing: convertPercentageToNumber(theme.letterSpacingDefault),
    },
    variants: {
      size: {
        small: {
          maxWidth: 140,
          minWidth: theme.sizingExtralarge,
          color: theme.colorTextNeutralReadonly,
          fontFamily: theme.fontFamily.regular,
          fontSize: theme.fontSizeThreeandhalfpulse,
          lineHeight: convertLineHeight(
            theme.fontSizeThreeandhalfpulse,
            theme.lineHeightSmall
          ),
        },
        medium: {
          maxWidth: theme.sizingHuge + theme.sizingColossal,
          minWidth: theme.sizingNano + theme.sizingEnormous,
          color: theme.colorTextNeutralAlternative,
          fontFamily: theme.fontFamily.bold,
          fontSize: theme.fontSizeFivepulse,
          lineHeight: convertLineHeight(
            theme.fontSizeFivepulse,
            theme.lineHeightTiny
          ),
        },
      },
    },
  }
})
